export const useMetaStore = defineStore('meta-store', {
	state: () => ({
		error: null,
		smoother: null,

		firstLoad: true,
		transitionDuration: 500,

		headerHeight: 455,
		loaderActive: false,
		menuActive: false,

		cursorActivated: false,
		cursorDisabled: false,
		scrollDisabled: false,

		activePageColors: {
			backgroundColor: 'red',
			foregroundColor: null,
			detailsColor: null,
			cursorBackgroundColor: null,
			cursorForegroundColor: null,
		}
	}),
	actions: {
		setActivePageColors(payload) {
			//eslint-disable-next-line 

			// console.log('store got payload', payload)

			const { $bus } = useNuxtApp()
			const colors = {
				...({ backgroundColor: payload && payload.background_color }),
				...({ foregroundColor: payload && payload.foreground_color }),
				...({ detailsColor: payload && payload.details_color }),
				...({ cursorBackgroundColor: payload && payload.cursor_background_color }),
				...({ cursorForegroundColor: payload && payload.cursor_foreground_color }),
			}

			// console.log('store colors', colors)

			if (Object.keys(colors).length) {
				Object.keys(colors).forEach(key => { if (colors[key] && !colors[key].includes('#') && colors[key] != 'transparent') { colors[key] = '#' + colors[key] } })
			}

			this.$patch({ activePageColors: colors })
			$bus.$emit('active-page-colors-changed')

			return this.activePageColors
		}
	},
	getters: {
		getDelay: (state) => {
			let duration = state.firstLoad ? state.transitionDuration : (state.transitionDuration)
			return duration
		}
	}
})